import { FC } from 'react'
import { cn } from '@wellesley/ui'
import useUploadProgress from './hooks'
import MediaStateContent from './MediaStateContent'

type MediaStateProps = {
  progress: number
  errorMessage: string | null
  uploadId: string
  isProcessing: boolean
  onProgressShown?: () => void
  onCancel?: (id: string) => void
}

const MediaState: FC<MediaStateProps> = ({
  progress,
  errorMessage,
  onCancel,
  uploadId,
  onProgressShown,
  isProcessing,
}) => {
  const isError = errorMessage !== null

  const { isSuccessVisible, isHidden } = useUploadProgress({
    progress,
    isError,
    onProgressShown,
    isProcessing,
  })

  if (isHidden && !isError) return null

  const iconWrapperSize = isSuccessVisible || isError ? 'size-l' : 'size-[70px]'

  return (
    <div
      className={cn(
        'absolute inset-0 z-[1] flex items-center justify-center',
        !isError && !isProcessing && 'backdrop-blur-[37px]',
        (isError || isProcessing) &&
          'bg-alpha-black-50 bg-cover bg-center bg-no-repeat',
      )}
      onClick={(e) => e.stopPropagation()}
      data-testid="upload-progress-overlay"
    >
      <div
        className={cn(
          'bg-alpha-black-30 relative z-[1] flex items-center justify-center rounded-full text-white',
          !isError && 'backdrop-blur-[3px]',
          isProcessing && 'animate-spin',
          iconWrapperSize,
        )}
        data-testid="upload-progress-circle"
      >
        <MediaStateContent
          progress={progress}
          onCancel={onCancel}
          uploadId={uploadId}
          errorMessage={errorMessage}
          isProcessing={isProcessing}
          isSuccessVisible={isSuccessVisible}
        />
      </div>
    </div>
  )
}

export default MediaState
